import React from "react";
import Progress10Svg from "../../../assets/svgicons/progress-bar/progress_bar_10.svg";

const Progress10 = (props) => {
  return <img src={Progress10Svg} alt="Progress 9" {...props} />;
};

export default Progress10;
